import React from 'react'
import PageTable from '../../../components/pageComponents/PageTable';
import FormSelect from '../../../components/atoms/Select';
import {handleFind} from '../../../helper/utils';
import ActionsIcons from "../../../components/atoms/ActionsIcons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import VerDetalleSolicitudBeneficio from "./modales/VerDetalleSolicitudBeneficio";
import ReactTooltip from "react-tooltip";
import {inactivarSolicitudBeneficioAPI} from "../../../consumers/backendApisUrls";
import ActionGenericModal from "../../../components/modal/ActionGenericModal";

const TableSolicitudesBeneficios = ({
                                        formValues,
                                        setFormValues,
                                        extraData,
                                        setModalEnabled,
                                        paginator,
                                        setPaginator,
                                        keys: KEYS,
                                        isAdmin
                                    }) => {
    const rows = formValues.Items;


    const HEADERS = [
        {col: "col-sm-1", label: "Fecha de Registro"},
        {col: "col-sm-1", label: "Campaña"},
        {col: "col-sm-2", label: "Nombre"},
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsCargos)}
                        description="Cargo"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsCargos] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsCargos)}
                    />
                </div>
        },
        {
            col: "col-sm-2", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsAreas)}
                        description="Área"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsAreas] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsAreas)}
                    />
                </div>
        },
        {
            col: "col-sm-2", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsSedes)}
                        description="Sede"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsSedes] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsSedes)}
                    />
                </div>
        },

        {col: "col-sm-2", label: "Monto"},
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsEstadosSolicitud)}
                        description="Est.Solicitud"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsEstadosSolicitud] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEstadosSolicitud)}
                    />
                </div>
        },
        {col: "", label: "Acciones"},
    ]

    const handleFilterSelected = (res, key) => {
        const updatedSelectedFilters = {...formValues.selectedFilters, [key]: res};
        setFormValues(lastData => ({...lastData, selectedFilters: updatedSelectedFilters}));
    }

    const handleActionRow = ({row, api, title, actionLabel}) => {
        const payload = {IdSolicitudBeneficio: row.IdSolicitudBeneficio};
        const data = {
            api,
            title,
            actionLabel,
            payload,
            name: `${row.NombreEmpleado}, con Monto: ${row.Monto}`
        };
        setModalEnabled({isEnable: true, component: ActionGenericModal, data});
    }

    return (
        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
            {rows.map((row) => (
                <tr key={row.IdSolicitudBeneficio}>
                    <td className="text-center">{row.FechaRegistro}</td>
                    <td className="text-center">{row.Campana}</td>
                    <td className="text-center">{row.NombreEmpleado}</td>
                    <td className="text-center">{row.Cargo}</td>
                    <td className="text-center">{row.Area}</td>
                    <td className="text-center">{row.Sede}</td>
                    <td className="text-center">{row.Monto}</td>
                    <td className="text-center">{row.Estado}</td>
                    <td className="text-center">
                        <ActionsIcons>
                            {row.MotivoRechazo &&
                                <ToolTip id={`MotivoRechazo${row.IdSolicitudBeneficio}`} text={row.MotivoRechazo}/>
                            }
                            {row.PuedeDesactivar &&
                                <FontAwesomeIcon
                                    icon={row.PuedeDesactivar ? "ban" : "circle-notch"}
                                    className=''
                                    size='lg'
                                    title={`${row.PuedeDesactivar ? "Inactivar" : "Activar"}`}
                                    onClick={() => handleActionRow({
                                        row,
                                        api: inactivarSolicitudBeneficioAPI,
                                        title: `${row.PuedeDesactivar ? "Inactivar": "Activar" }`,
                                        actionLabel: `${row.PuedeDesactivar ? "inactivar": "activar" }`
                                    })}
                                />
                            }
                            <FontAwesomeIcon
                                icon="id-card"
                                title="Ver Detalle Solicitud"
                                size="lg"
                                onClick={() =>
                                    setModalEnabled({
                                        isEnable: true,
                                        component: VerDetalleSolicitudBeneficio,
                                        data: {row, isAdmin},
                                    })
                                }
                            />
                        </ActionsIcons>
                    </td>
                </tr>
            ))}
            </tbody>
        </PageTable>
    );
}

export default TableSolicitudesBeneficios;

const ToolTip = ({id, text}) => (
    <div>
        <FontAwesomeIcon data-tip data-for={id} icon='info-circle' title='Motivo Rechazo' size='lg'
                         style={{color: "#b3a11a"}}/>
        <ReactTooltip id={id} place="top" effect="solid" className="tooltip-style">
            Motivo de Rechazo: {text}
        </ReactTooltip>
    </div>
)